import React, { useEffect, useState } from "react";
import { Button, Input, Dropdown, AlertMessage, CoreLoader, Textarea, Label, CheckBox } from "common/components";
import apiManager from "networking/baseAPIManager";

function CreateRequest({ fetchapi }) {
  const [leaveTypeOptions, setLeaveTypeOptions] = useState([]);
  const [selectType, setSelectType] = useState("");
  const [selectEndDate, setselectEndDate] = useState("");
  const [selectStartDate, setSelectStartDate] = useState("");
  const [Session, setSession] = useState("");
  const [selectReason, setReason] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showMSG, setShowMSG] = useState(false);
  const [msgType, setmsgType] = useState("info");
  const [showInput, setShowInput] = useState(false);

  const leaveTypeOption = [
    { key: "session1", value: "Session 1" },
    { key: "session2", value: "Session 2" },
  ];
  const datesMatch = selectStartDate === selectEndDate;

  useEffect(() => {
    if (!datesMatch) {
      setShowInput(false);
    }
  }, [datesMatch]);

  const leaveTypes = "leaveTypes";
  const fetchLeaveTypeOptions = () => {
    setLoading(true);
    apiManager
      .getDropdownTypes(leaveTypes)
      .then((response) => {
        setLeaveTypeOptions(response.data.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching leave type options:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchLeaveTypeOptions(leaveTypes);
  }, []);
  const handleLeaveSubmit = (e) => {
    e.preventDefault();
    let formdata = new FormData();
    formdata.append("type", selectType);
    formdata.append("start_date", selectStartDate);
    formdata.append("end_date", selectEndDate);
    formdata.append("session", Session);
    formdata.append("reason", selectReason);
    formdata.append("document", selectedFile);
    setLoading(true);
    apiManager
      .createLeave(formdata)
      .then((res) => {
        setLoading(false);
        fetchapi && fetchapi();
        setmsgType("success");
        setShowMSG(res?.data?.message || "details updated successfully");
        resetFormFields();
      })
      .catch((err) => {
        setLoading(false);
        setmsgType("error");
        setShowMSG(err?.response?.data?.message || "failed to update");
        console.log(err, "leave Request error");
      });
  };
  const resetFormFields = () => {
    setSelectType("");
    setSelectStartDate("");
    setselectEndDate("");
    setSession("");
    setReason("");
    setSelectedFile(null);
    const fileInput = document.getElementById("attachment");
    if (fileInput) {
      fileInput.value = "";
    }
  };
  const handleDeleteClick = () => {
    setSelectType("");
    setSelectStartDate("");
    setselectEndDate("");
    setSession("");
    setReason("");
    setSelectedFile("");
  };
  const getLastMonthFormatted = () => {
    const currentDate = new Date();
    const lastMonth = new Date(currentDate);
    lastMonth.setMonth(currentDate.getMonth() - 1);
    const formattedDate = lastMonth.toISOString().split("T")[0];
    return formattedDate;
  };

  return (
    <>
      <div className="col-lg-12 px-5 pt-5">
        <AlertMessage show={showMSG} setShow={setShowMSG} type={msgType} />
        <div className=" pt-5 form-main ">
          <div className="row pb-5">
            <div className="form-container container">
              <div className="col-lg-8 m-auto">
                <form className="leave-request  ">
                  <div className="col-lg-12 form-outline mb-4 row align-items-center ms-0">
                    <Label label="Leave Type" parentclasses="col-lg-4 d-flex justify-content-center ps-4 " />
                    <Dropdown
                      parentclasses="col-lg-8 "
                      value={selectType}
                      onChange={(e) => {
                        setSelectType(e.target.value);
                      }}
                      options={leaveTypeOptions}
                      placeholder="Select Leave Types"
                      sidelabel
                    />
                  </div>
                  <div className=" col-lg-12 form-outline mb-4 row align-items-center ms-0">
                    <Label label="Start Date" parentclasses="col-lg-4 d-flex justify-content-center ps-4  " />
                    <Input
                      parentclasses="col-lg-8  "
                      inputclasses="form-controlcustom"
                      type="date"
                      name="startDate"
                      value={selectStartDate}
                      onChange={(e) => {
                        setSelectStartDate(e.target.value);
                      }}
                      condition={getLastMonthFormatted()}
                    />
                  </div>
                  <div className=" col-lg-12 form-outline mb-4 row align-items-center ms-0">
                    <Label label="End Date" parentclasses="col-lg-4 d-flex justify-content-center ps-4 " />
                    <Input
                      parentclasses="col-lg-8 "
                      inputclasses="form-controlcustom"
                      type="date"
                      name="endDate"
                      value={selectEndDate}
                      onChange={(e) => {
                        setselectEndDate(e.target.value);
                      }}
                      min={getLastMonthFormatted()}
                      condition={selectStartDate}
                    />
                  </div>
                  <div className=" col-lg-12 form-outline mb-4 row align-items-center ms-0">
                    <Label label="Half-day" parentclasses="col-lg-4 d-flex justify-content-center ps-4" />

                    <Input
                      type="checkbox"
                      parentclasses="col-lg-2   "
                      inputclasses="form-check-input "
                      style={{ height: "37px", width: "35px" }}
                      checked={showInput}
                      l
                      onChange={(e) => {
                        setShowInput(e.target.checked);
                      }}
                      disabled={!datesMatch}
                    />
                    {showInput && (
                      <Dropdown
                        parentclasses="col-lg-6 "
                        id="dropdown"
                        name="session"
                        value={Session}
                        onChange={(e) => {
                          setSession(e.target.value);
                        }}
                        options={leaveTypeOption}
                        placeholder="Select Session"
                        datesMatch={selectStartDate === selectEndDate}
                      />
                    )}
                  </div>
                  <div className="col-lg-12 form-outline mb-4 row align-items-center ms-0">
                    <Label label="Reason" parentclasses="col-lg-4 d-flex justify-content-center " />
                    <Textarea
                      parentclasses="col-lg-8  "
                      name="reason"
                      value={selectReason}
                      onChange={(e) => {
                        setReason(e.target.value);
                      }}
                    />
                  </div>
                  <div className=" col-lg-12 form-outline mb-4 row align-items-center ms-0">
                    <Label label="Attachment" parentclasses="col-lg-4 d-flex justify-content-center ps-5  " />
                    <Input
                      parentclasses="col-lg-8 "
                      inputclasses="form-controlcustom"
                      type="file"
                      id="attachment"
                      name="attachment"
                      onChange={(e) => {
                        setSelectedFile(e.target.files[0]);
                      }}
                      sidelabel
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="d-flex gap-3 justify-content-end subheaderbackground p-2 px-4">
            <Button
              onClick={(e) => handleLeaveSubmit(e)}
              className="btn btn-primary sub-btn"
              variant="primary"
              type="submit"
              label="Submit"
            />
            <Button
              className=" btn btn-primary can-btn  "
              onClick={handleDeleteClick}
              variant="primary"
              type="Cancel"
              label="Cancel"
            />
          </div>
        </div>
      </div>
      <CoreLoader show={loading} disableLines />
    </>
  );
}

export default CreateRequest;
